var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaunchpool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_31006_2651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1543 16.7921V28.2376C43.1543 32.18 41.0845 35.868 37.6975 37.8392L31.9271 41.2092L31.2371 41.5907L27.9129 43.4983C26.6584 44.1978 25.3413 44.6429 24.0241 44.8972C23.7732 44.9608 23.585 44.9608 23.3342 44.9608C21.1389 45.1516 18.9436 44.6429 16.9365 43.4983L11.9188 40.5734L11.2288 40.1918L7.21462 37.8392C3.82764 35.868 1.75781 32.18 1.75781 28.2376V16.7921C1.75781 12.8497 3.82764 9.16174 7.21462 7.19056L14.6785 2.80311L15.243 2.48518L16.9365 1.53138C18.3791 0.704759 19.9472 0.196069 21.5152 0.0688963C21.7661 0.0688963 21.9543 0.0688961 22.2052 0.00530981C24.1495 -0.0582765 26.1567 0.450414 27.9129 1.46779L35.8785 6.10959L37.0703 6.80904L37.6975 7.19056C41.0845 9.16174 43.1543 12.8497 43.1543 16.7921Z",
    fill: "#00826C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5697 25.4257C37.4891 25.6682 37.4892 25.9914 37.4086 26.2338C37.2474 26.7994 37.0863 27.2843 36.9252 27.8499C36.8446 28.1731 36.6833 28.4152 36.6027 28.7385C34.9103 32.5363 31.7674 35.3645 27.9797 36.819C27.6573 36.9806 27.2543 37.0614 26.932 37.2231C26.6902 37.3039 26.4484 37.3848 26.2872 37.3848C24.1113 37.9505 21.7742 38.0314 19.4371 37.5466C11.1365 35.8497 5.73714 27.6074 7.5101 19.2844C9.20247 10.9614 17.4225 5.54723 25.7231 7.32495C28.7049 7.9714 31.3645 9.42606 33.4598 11.527C37.0057 15.0825 38.6174 20.335 37.5697 25.4257Z",
    fill: "#00705C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8332 27.8413C36.7526 28.1646 36.5914 28.407 36.5108 28.6494C34.8184 32.4473 31.6755 35.2755 27.8878 36.73L14.5906 23.397L20.0706 19.9224L25.2283 25.9828L30.5472 21.5385L36.8332 27.8413Z",
    fill: "url(#paint0_linear_31006_2651)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0196 27.6803L20.3125 20.8926C20.2319 20.731 19.9901 20.6502 19.8289 20.731C19.7483 20.731 19.7483 20.8118 19.7483 20.8118L17.8142 23.3168C17.7336 23.4784 17.4919 23.5592 17.3307 23.5592H14.8324C14.5906 23.5592 14.3489 23.3168 14.3489 23.0744V21.6199C14.3489 21.3775 14.5906 21.1351 14.8324 21.1351H16.2024C16.3636 21.1351 16.5248 21.0543 16.686 20.8926L19.8289 16.8524C20.0707 16.5291 20.5542 16.4483 20.8766 16.6908C20.9572 16.7716 21.0378 16.8524 21.0378 16.9332L24.6643 23.64C24.7449 23.8017 24.9866 23.8825 25.1478 23.8016C25.2284 23.8016 25.2284 23.7208 25.2284 23.7208L27.0014 21.2967C27.082 21.1351 27.3237 21.0543 27.4849 21.0543H30.0638C30.3055 21.0543 30.5473 21.2967 30.5473 21.5391V22.9936C30.5473 23.236 30.3055 23.4784 30.0638 23.4784H28.6937C28.5326 23.4784 28.3714 23.5592 28.2102 23.7208L25.2284 27.6803C24.9866 28.0035 24.5031 28.0843 24.1807 27.8419C24.1002 27.8419 24.1002 27.7611 24.0196 27.6803Z",
    fill: "url(#paint1_linear_31006_2651)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_31006_2651",
    x: 1.75781,
    y: 0,
    width: 41.3965,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 80
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_31006_2651"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31006_2651",
    x1: 23.9089,
    y1: 23.835,
    x2: 32.2099,
    y2: 32.1138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5C49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053A11",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31006_2651",
    x1: 26.3325,
    y1: 26.0986,
    x2: 19.2281,
    y2: 19.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#B0FFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchpool);
export default __webpack_public_path__ + "static/media/launchpool.ca137984.svg";
export { ForwardRef as ReactComponent };